(() => {
  if (customElements.get('newsletter-signup')) return;

  class NewsletterSignup extends HTMLElement {
    connectedCallback() {
      this.form = this.querySelector('form.newsletter__form');
      this.template = this.querySelector('[data-newsletter-template]');
      if (!this.form || !this.template || !window.fetch) return;
      this.form.addEventListener('submit', (event) => this.onSubmit(event));
    }

    async onSubmit(event) {
      if (this.submitting) return;
      const email = this.form.querySelector('input[type="email"]');
      if (email && !email.checkValidity()) return;
      event.preventDefault();
      this.submitting = true;
      const button = this.form.querySelector('button[type="submit"]');
      button?.setAttribute('aria-busy', 'true');
      try {
        const response = await fetch(this.form.action, {
          method: 'POST',
          body: new FormData(this.form),
          credentials: 'same-origin',
        });
        const url = new URL(response.url, window.location.origin);
        if (response.ok && url.searchParams.get('customer_posted') === 'true') {
          this.showSuccess();
          return;
        }
        this.fallback();
      } catch (error) {
        this.fallback();
      }
    }

    showSuccess() {
      const success = this.template.content.firstElementChild.cloneNode(true);
      this.form.replaceChildren(success);
      success.focus({ preventScroll: true });
      this.submitting = false;
    }

    fallback() {
      this.submitting = true;
      HTMLFormElement.prototype.submit.call(this.form);
    }
  }

  customElements.define('newsletter-signup', NewsletterSignup);
})();
